import React from "react";
import { Card, Table, Badge } from "react-bootstrap";
import { MessageSquare, Zap } from "lucide-react";

const PartnerPlanHistoryTable = ({ currentPartner }) => {
  const history = Array.isArray(currentPartner?.partnerPlanHistory)
    ? currentPartner.partnerPlanHistory
    : [];

  return (
    <Card className="premium-card qx-section-card qx-table-card mb-4">
      <Card.Body>
        <div className="d-flex align-items-center justify-content-between px-3 pt-3 pb-2 flex-wrap gap-2">
          <h6 className="qx-section-card__title text-uppercase small mb-0">
            Package Assignment & Purchase History
          </h6>
          {history.length > 0 && (
            <Badge bg="light" text="dark" className="border px-3 py-2">
              {history.length} {history.length === 1 ? "record" : "records"}
            </Badge>
          )}
        </div>

        {history.length > 0 ? (
          <Table responsive className="mb-0 align-middle">
            <thead>
              <tr>
                <th><strong>S.NO</strong></th>
                <th><strong>Package Name</strong></th>
                <th><strong>Package Type</strong></th>
                <th><strong>Actual Amount</strong></th>
                <th><strong>Received Amount</strong></th>
                <th><strong>Assigned Date</strong></th>
              </tr>
            </thead>
            <tbody>
              {history.map((item, idx) => {
                const isWa = Boolean(item.whatsappPlanId);
                const isSub = Boolean(item.subscriptionId);
                const planObj = isWa ? item.whatsappPlanId : isSub ? item.subscriptionId : null;

                const rawName =
                  (typeof planObj === "object" ? planObj?.name : null) ||
                  item.name ||
                  (isWa ? "WhatsApp Package" : "Partner Package");
                const price = (typeof planObj === "object" ? planObj?.price : null) || item.price;
                const receivedAmt =
                  item.receiverAmount !== undefined && item.receiverAmount !== null
                    ? item.receiverAmount
                    : price;

                const formattedDate =
                  item.createdAt || item.updatedAt
                    ? new Date(item.createdAt || item.updatedAt).toLocaleDateString("en-IN", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                      })
                    : "—";

                return (
                  <tr key={item._id || item.id || idx}>
                    <td>{idx + 1}</td>
                    <td className="fw-semibold text-capitalize">
                      {isWa ? (
                        <MessageSquare size={16} className="me-2" style={{ color: "#A60000" }} />
                      ) : (
                        <Zap size={16} className="me-2" style={{ color: "#A60000" }} />
                      )}
                      {rawName}
                    </td>
                    <td>
                      {isWa ? (
                        <Badge bg="success" className="px-2 py-1" style={{ backgroundColor: "#059669" }}>
                          WhatsApp Package
                        </Badge>
                      ) : (
                        <Badge className="px-2 py-1" style={{ backgroundColor: "#800001" }}>
                          Partner Package
                        </Badge>
                      )}
                    </td>
                    <td>
                      {price !== undefined && price !== null && price !== ""
                        ? `₹${Number(price).toLocaleString("en-IN")}`
                        : "—"}
                    </td>
                    <td>
                      {receivedAmt !== undefined && receivedAmt !== null && receivedAmt !== ""
                        ? `₹${Number(receivedAmt).toLocaleString("en-IN")}`
                        : "—"}
                    </td>
                    <td>{formattedDate}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        ) : (
          <div className="qx-empty-state py-4">
            <p className="mb-0 text-muted">No plan assignment history for this partner.</p>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default PartnerPlanHistoryTable;
